import { PropsWithChildren } from 'react'

export const Invisible = ({ children }: PropsWithChildren<object>) => <div style={{ display: 'none' }}>{children}</div>
